import * as React from "react"

const Mail = (props) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 88.86"
    {...props}
  >
    <title>{"email"}</title>
    <path d="M7.05 0h108.78a7.07 7.07 0 0 1 7 7.05v74.76a7 7 0 0 1-1.22 4 2.78 2.78 0 0 1-.66 1 2.62 2.62 0 0 1-.66.46 7 7 0 0 1-4.51 1.65H7.05a7.07 7.07 0 0 1-7-7V7.05a7.07 7.07 0 0 1 7-7.05Zm-.3 78.84 36.78-38.22L6.75 9.54v69.3Zm42.32-33.45L9.77 83.45h103L75.22 45.39l-11 9.21a2.7 2.7 0 0 1-3.45 0l-11.7-9.21Zm31.6-4.84 35.46 38.6V9.2L80.67 40.55ZM10.21 5.41 62.39 47.7l49.88-42.29Z" />
  </svg>
)

export default Mail
